var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "block" }, [
    _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t("forms.createstandards.wouldyoulike")))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "buttons" }, [
      _c("a", { staticClass: "button", on: { click: _vm.showModal } }, [
        _vm._m(0),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("forms.createstandards.createstandards"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.exercise
      ? _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.createStandards.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "Modal",
              {
                ref: "modal",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$t("forms.createstandards.createstandards")
                            )
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "button is-primary",
                              attrs: {
                                type: "submit",
                                name: "action",
                                value: "addbodyweightgoal",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("forms.createstandards.create")
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4076394990
                ),
              },
              [
                _vm._v(" "),
                _vm.errorMessage
                  ? _c(
                      "div",
                      {
                        staticClass: "notification is-warning",
                        attrs: { lang: "en" },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.errorMessage) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "field is-horizontal" }, [
                  _c("div", { staticClass: "field-label is-normal" }, [
                    _c(
                      "label",
                      { staticClass: "label", attrs: { for: "exercise" } },
                      [_vm._v(_vm._s(_vm.$t("forms.createstandards.exercise")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field has-addons" }, [
                      _c("div", { staticClass: "control is-expanded" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.exercise.name,
                              expression: "exercise.name",
                            },
                          ],
                          staticClass: "input",
                          attrs: {
                            type: "text",
                            id: "exercise",
                            name: "exercise",
                            disabled: "",
                          },
                          domProps: { value: _vm.exercise.name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.exercise,
                                "name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("GenderSetting", {
                  model: {
                    value: _vm.genderSelection,
                    callback: function ($$v) {
                      _vm.genderSelection = $$v
                    },
                    expression: "genderSelection",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "field is-horizontal" }, [
                  _c("div", { staticClass: "field-label is-normal" }, [
                    _c(
                      "label",
                      { staticClass: "label", attrs: { for: "age" } },
                      [_vm._v(_vm._s(_vm.$t("forms.createstandards.age")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field has-addons" }, [
                      _c("div", { staticClass: "control is-expanded" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.age,
                              expression: "age",
                            },
                          ],
                          staticClass: "input",
                          attrs: {
                            type: "number",
                            id: "age",
                            name: "age",
                            min: "5",
                            max: "400",
                          },
                          domProps: { value: _vm.age },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.age = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "control" }, [
                        _c("span", { staticClass: "button is-static" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("forms.createstandards.yearsold")) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("BodyweightSetting", {
                  ref: "bodyweightSetting",
                  attrs: {
                    "body-mass-view-model": _vm.bodyMassViewModel,
                    required: false,
                    label: _vm.$t("forms.createstandards.bodyweight"),
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.exercise
      ? _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.goBack.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "Modal",
              {
                ref: "tableModal",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$t("forms.createstandards.createstandards")
                            )
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "button is-primary",
                              attrs: {
                                type: "submit",
                                name: "action",
                                value: "addbodyweightgoal",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("forms.createstandards.back")) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  567685633
                ),
              },
              [
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "field is-grouped is-grouped-multiline" },
                  [
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "tags has-addons are-medium" }, [
                        _c("span", { staticClass: "tag is-primary" }, [
                          _vm._v(
                            _vm._s(_vm.$t("forms.createstandards.exercise"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "tag" }, [
                          _vm._v(_vm._s(_vm.exercise.name)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "tags has-addons are-medium" }, [
                        _c("span", { staticClass: "tag is-primary" }, [
                          _vm._v(
                            _vm._s(_vm.$t("forms.createstandards.gender"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "tag" }, [
                          _vm._v(_vm._s(_vm.$t("enums.gender." + _vm.gender))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.age
                      ? _c("div", { staticClass: "control" }, [
                          _c(
                            "div",
                            { staticClass: "tags has-addons are-medium" },
                            [
                              _c("span", { staticClass: "tag is-primary" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("forms.createstandards.age"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "tag" }, [
                                _vm._v(_vm._s(_vm.age)),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bodyweightForRequest
                      ? _c("div", { staticClass: "control" }, [
                          _c(
                            "div",
                            { staticClass: "tags has-addons are-medium" },
                            [
                              _c("span", { staticClass: "tag is-primary" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("forms.createstandards.bodyweight")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "tag" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.bodyweightForRequest + " " + _vm.unit
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("DataTable", { attrs: { table: _vm.table } }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", {
        staticClass: "slicon slicon-fa-square-plus",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }